// FormikDatePicker.js

import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { ErrorMessage, FastField, Field } from "formik";
import TextError from "../TextError";
import CustomDatePicker from "./CustomDatePicker";
import FormikControlContext from "../../../Contexts/FormikControlContext";

const FormikDatePicker = () => {
  const field = useContext(FormikControlContext);
  const { label, name, validation, readOnly } = field;

  const DatePickerField = readOnly === undefined ? Field : FastField;

  return (
    <Box>
      <Typography>
        {label}
        {validation?.required && <span>*</span>}
      </Typography>

      <DatePickerField
        className="form-control"
        label={label}
        id={name}
        name={name}
        placeholder={label}
        component={CustomDatePicker}
        required={validation?.required ?? false}
      />

      <ErrorMessage name={name} component={TextError} />
    </Box>
  );
};

export default FormikDatePicker;
